import React, { FC, Fragment } from "react";

import classnames from "classnames";

import { Logo } from "components/shared/generic/logo/logo";

import { NavigationBarIcon } from "components/cosmos";

import { Grid } from "components/shared/generic/grid/grid";
import { GridRow } from "components/shared/generic/grid/grid-row";
import { GridCol } from "components/shared/generic/grid/grid-col";

import { LandingNavigationMenu } from "components/landing/landing-navigation-menu/landing-navigation-menu";

import styles from "./landing-top-navbar.module.scss";

type Props = {
  basePath?: string;
  isFloating: boolean;
  isMobileMenuOpen: boolean;
  onMobileMenuButtonClick: () => void;
  onMenuLinkClick?: () => void;
};

export const LandingTopNavbar: FC<React.PropsWithChildren<Props>> = (props) => {
  const {
    basePath,
    isFloating = false,
    isMobileMenuOpen,
    onMobileMenuButtonClick,
    onMenuLinkClick,
  } = props;

  const className = classnames({
    [styles.root]: true,
    [styles.isFloating]: isFloating,
  });

  return (
    <Fragment>
      <div className={className}>
        <Grid hasStrictWidth={true}>
          <GridRow alignItems={"center"}>
            <GridCol>
              <Logo />
            </GridCol>
            <GridCol justifyContent={"flex-end"}>
              <div className={styles.mobileMenuButton}>
                <NavigationBarIcon
                  name={"navigation-bar-hamburger-menu"}
                  a11y={{ iconLabel: "Open menu" }}
                  onClick={onMobileMenuButtonClick}
                />
              </div>
              <div className={styles.desktopMenu}>
                <LandingNavigationMenu basePath={basePath} />
              </div>
            </GridCol>
          </GridRow>
        </Grid>
        {isMobileMenuOpen ? (
          <div className={styles.mobileMenuContainer}>
            <Grid>
              <GridRow>
                <GridCol>
                  <LandingNavigationMenu
                    basePath={basePath}
                    onLinkClick={onMenuLinkClick}
                  />
                </GridCol>
              </GridRow>
            </Grid>
          </div>
        ) : null}
      </div>
      <div className={styles.placeholder} />
    </Fragment>
  );
};
